import ForumPostRequestResource from "common/resources/Project/Config/Forum/ForumPostRequestResource";
import ForumPostResponseResource from "common/resources/Project/Config/Forum/ForumPostResponseResource";
import BasePostApi from "./BasePostApi";
import { createFormData } from "utils/FormData";

export default class PostApi extends BasePostApi {
	/**
	 * @description Get all general posts by project id
	 */
	public async getGeneralPosts(projectId: string): Promise<ForumPostResponseResource[]> {
		return this.getRequest<ForumPostResponseResource[]>(this.getBaseUrl({ projectId })).then((response) => ForumPostResponseResource.hydrateArray(response));
	}

	/**
	 * @description Get all casting posts by project id
	 */
	public async getCastingPosts(projectId: string): Promise<ForumPostResponseResource[]> {
		return this.getRequest<ForumPostResponseResource[]>(`${this.getBaseUrl({ projectId })}/casting`).then((response) => ForumPostResponseResource.hydrateArray(response));
	}

	/**
	 * @description Get all archived posts by project id
	 */
	public async getArchivedPosts(projectId: string): Promise<ForumPostResponseResource[]> {
		return this.getRequest<ForumPostResponseResource[]>(`${this.getBaseUrl({ projectId })}/archived`).then((response) => ForumPostResponseResource.hydrateArray(response));
	}

	/**
	 * @description Create a new creative source for a project
	 */
	public async create(projectId: string, request: ForumPostRequestResource, image?: File): Promise<ForumPostResponseResource> {
		const formData = createFormData(request);

		if (image) formData.append("file", image);

		return this.postRequestFormdata<ForumPostResponseResource>(this.getBaseUrl({ projectId }), formData).then((response) => ForumPostResponseResource.hydrate(response));
	}
}
